module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAARCAYAAADZsVyDAAABBElEQVQ4T63UMW7CQBCF4fdcUKYLRwAh5QhgKo4AacMdaHBAQkixCw6RtMARUhmuECHOQNpUKXaQIUKy8c6uCW535tPql7WExyczBPjt9E6jte0nZzCuNboGsnOJuu+AvJxn+cE4Hbr2nLC8dvsQWeUgcsC3dK3hKizjziMCfkFQz8M4wMgTk+23DdfhKMxu2rcsrxlvBpXh0gRFRUlSemNrgivYnqQc1hMU+dIkV7BXAo8kOdg7gUeSPFwtgZrkAt+UQElygm9OoCQ5w1G4BGD92V3vQuF8xXjzTJmELRjsKi7r42KalHG7AQb77Nm6G57Bf8/iFDAjgA//wokfGC6YpPMjYClyxnr8HBYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_detail_eight_up.png
// module id = YozW
// module chunks = 0